import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=22c0b8c7&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&id=22c0b8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0b8c7",
  null
  
)

export default component.exports